import { Stack, Typography } from '@rossum/ui/material';
import { SchemaFieldIconType } from '../../../../ui/schema-field-icon/SchemaFieldIcon';
import { CellIcons } from './CellIcons';

type HeaderCellProps = {
  iconType?: SchemaFieldIconType | null;
  primaryText: string | undefined;
  secondaryText: string | undefined;
};

const HeaderCell = ({
  secondaryText,
  iconType,
  primaryText,
}: HeaderCellProps) => (
  <Stack spacing={1} direction="row" component="span">
    <Stack>
      <Typography variant="body2">{primaryText ?? ''}</Typography>
      <Typography variant="caption" color="text.secondary">
        {secondaryText ?? ''}
      </Typography>
    </Stack>
    {iconType ? <CellIcons type={iconType} /> : null}
  </Stack>
);

export { HeaderCell };
